import {
  addressValidationQueryOptions,
  UsState,
} from '@branch-messenger/willow-ui'
import { FlowCardLoading } from '@components/FlowCard'
import { AddressRecommendation } from '@components/RouteComponents'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_initialized/address/addressRecommendation'
)({
  loader: ({ context: { queryClient, store } }) => {
    const state = store.getState().onboarding
    const address = state.enteredAddress
    if (address)
      return {
        data: queryClient.ensureQueryData(
          addressValidationQueryOptions({
            address: {
              streetLine: address.address_1,
              secondary: address.address_2,
              city: address.city,
              state: address.state as UsState,
              zipcode: address.zip,
            },
          })
        ),
      }
  },
  component: AddressRecommendation,
  pendingComponent: FlowCardLoading,
})
